import React from 'react';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Widget } from '../../_lib/components/Widget';
import { UserAnonymousBlock } from '../../_blocks/UserAnonymous';

export type UserAnonymousWidget = WidgetShape<[UserAnonymousBlock], WidgetType.useranonymous>;

export function UserAnonymousWidget({ blocks, elementType, uuid }: UserAnonymousWidget) {
  return (
    <Widget uuid={uuid} widgetType={elementType}>
      <UserAnonymousBlock {...blocks[0]} />
    </Widget>
  );
}
